import { Checkbox, CircularProgress, FormHelperText } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { DropdownOption } from "src/types/general";

interface DropdownProps {
  label: string;
  items?: DropdownOption[];
  value: any;
  onChange: (value: any) => void;
  warn?: boolean;
  size?: "small" | "medium";
  disabled?: boolean;
  multiple?: boolean;
  width?: number | string;
  hideDefaultValue?: boolean;
  mandatory?: boolean;
}

export default function Dropdown({
  label,
  items,
  value,
  onChange,
  warn,
  size,
  disabled,
  multiple,
  width,
  mandatory,
  hideDefaultValue,
}: DropdownProps) {
  return (
    <Box sx={{ position: "relative", minWidth: width ? width : 120, paddingLeft: 0 }}>
      <FormControl
        size={size}
        fullWidth
        error={warn}
        disabled={disabled}
        style={{ paddingLeft: "0px" }}
      >
        <InputLabel style={{ color: "#808080", marginLeft: "-2px" }}>{label}</InputLabel>
        <Select
          value={value || "0"}
          defaultValue={value || "0"}
          variant="outlined"
          defaultChecked={!!value || false}
          style={{ background: "transparent" }}
          label={
            <span>
              {label}
              {mandatory && <span style={{ color: "red", fontSize: "16px" }}>*</span>}
            </span>
          }
          disabled={disabled || !items}
          multiple={multiple}
          renderValue={(selected) => {
            if (multiple && items) {
              const newSelected = items?.map((item) => {
                if (selected && selected.includes(item?.value)) {
                  return item?.label;
                } else {
                  return false;
                }
              });
              return newSelected.filter((select) => select !== false).join(", ");
            } else if (items) {
              return items?.find((item) => selected === item.value)?.label || "";
            }
          }}
          onChange={(e) =>
            multiple && e.target.value.includes("resetSelections")
              ? onChange({ value: [] })
              : onChange(e.target.value)
          }
        >
          {!hideDefaultValue && (
            <MenuItem value={multiple ? "resetSelections" : "0"}>
              <em>{multiple ? "--Reset Selections--" : "--Select--"}</em>
            </MenuItem>
          )}
          {items &&
            items.map((item) => {
              return (
                <MenuItem
                  key={"option-" + item.value}
                  value={item?.value}
                >
                  {multiple && <Checkbox checked={value.indexOf(item?.value) > -1} />}
                  {item?.label}
                </MenuItem>
              );
            })}
        </Select>
        {warn && <FormHelperText>This field is mandatory.</FormHelperText>}
      </FormControl>
      {!items && !disabled && (
        <CircularProgress
          size={30}
          style={{
            position: "absolute",
            top: "12px",
            right: "10px",
            background: "white",
          }}
        />
      )}
    </Box>
  );
}
